<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="60%"
    @close="closeDialog"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="auto">
      <el-row>
        <el-col :span="10">
          <el-form-item label="办学形式：" prop="runningForms">
            <el-select
              v-model="form.runningForms"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in runningFormsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :push="4" :span="10">
          <el-form-item label="办学形式代码：" prop="runningFormsCode">
            <el-input v-model="form.runningFormsCode" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="专业名称：" prop="majorName">
            <el-input v-model="form.majorName" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :push="4" :span="10">
          <el-form-item label="专业代码：" prop="majorNameCode">
            <el-input v-model="form.majorNameCode" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="培养层次：" prop="trainingLevel">
            <el-select
              v-model="form.trainingLevel"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in trainingLevelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :push="4" :span="10">
          <el-form-item label="层次代码：" prop="trainingLevelCode">
            <el-input v-model="form.trainingLevelCode" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="开考状态：" prop="examStatus">
            <el-select
              v-model="form.examStatus"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in examStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :push="4" :span="10">
          <el-form-item label="状态代码：" prop="examStatusCode">
            <el-input v-model="form.examStatusCode" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="是否启用：" prop="startUsing">
            <el-radio v-model="form.startUsing" label="1">启用</el-radio>
            <el-radio v-model="form.startUsing" label="2">停用</el-radio>
          </el-form-item>
        </el-col>
        <el-col :push="4" :span="10">
          <el-form-item label="设置首页推荐：" prop="recommend">
            <el-checkbox v-model="form.recommend">推荐专业</el-checkbox>
            <span style="margin-left: 20px">首页推荐剩余: 24</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="门类大类：" prop="mainClass">
            <el-input v-model="form.mainClass" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :push="4" :span="10">
          <el-form-item label="专业类：" prop="professionalClass">
            <el-input v-model="form.professionalClass" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="排序号：" prop="orderBy">
            <el-input v-model="form.orderBy" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="培养目标：" prop="trainingTarget">
            <el-input
              v-model="form.trainingTarget"
              type="textarea"
              :rows="4"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="培养要求：" prop="trainingRequirements">
            <el-input
              v-model="form.trainingRequirements"
              type="textarea"
              :rows="10"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="主干学科：" prop="mainSubject">
            <el-input
              v-model="form.mainSubject"
              type="textarea"
              :rows="4"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="课程设置要求：" prop="courseRequirements">
            <el-input
              v-model="form.courseRequirements"
              type="textarea"
              :rows="10"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="其它说明：" prop="explain">
            <el-input
              v-model="form.explain"
              type="textarea"
              :rows="4"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="封面上传：" prop="file">
            <el-row>
              <el-col :span="3">
                <el-upload
                  class="upload-demo"
                  action="#"
                  multiple
                  :limit="1"
                  :before-upload="beforeUpload"
                  :on-change="changeUpload"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </el-col>
              <el-col :span="6">
                <span style="font-size: 14px; color: #aaa"
                  >建议尺寸: 100px*100px</span
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="display: flex; justify-content: center">
          <el-checkbox v-model="continuousInput">连续录入</el-checkbox>
        </el-col>
      </el-row>
    </el-form>

    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: center"
    >
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="dialogVisible = false">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: '添加专业',
      dialogVisible: true,
      form: {
        runningForms: '',
        runningFormsCode: '',
        majorName: '',
        majorNameCode: '',
        trainingLevel: '',
        trainingLevelCode: '',
        examStatus: '',
        examStatusCode: '',
        startUsing: '1',
        recommend: '',
        mainClass: '',
        professionalClass: '',
        orderBy: '',
        trainingTarget: '',
        trainingRequirements: '',
        mainSubject: '',
        courseRequirements: '',
        explain: '',
        file: '',
      },
      rules: {
        runningForms: [
          { required: true, message: '请选择办学形式', trigger: 'blur' },
        ],
        majorName: [
          { required: true, message: '请填写专业名称', trigger: 'blur' },
        ],
        majorNameCode: [
          { required: true, message: '请输入专业代码', trigger: 'blur' },
        ],
        trainingLevel: [
          { required: true, message: '请选择培养层次', trigger: 'blur' },
        ],
        examStatus: [
          { required: true, message: '请选择开考状态', trigger: 'blur' },
        ],
      },
      runningFormsList: [],
      trainingLevelList: [],
      examStatusList: [],
      continuousInput: '',
      fileList: [],
    }
  },
  methods: {
    beforeUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png']
      const isImage = types.includes(file.type)
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        return this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isImage && isLt2M
    },
    changeUpload(file) {
      this.form.file = file.raw
    },
    save() {
      // this.$refs.form.validate((valid) => {
      //   // if (valid) {
      //   //   console.log(1)
      //   // }
      //   if (this.continuousInput) {
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    closeDialog() {
      this.$emit('closeAddProfession')
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__header {
    background-color: #f2f2f2;
    font-weight: 700;
  }
}
</style>